import {
  EcmUserModel,
  PeopleContentService,
} from '@alfresco/adf-content-services';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class WkEcmUserService {
  constructor(private readonly ecmUserService: PeopleContentService) {}

  getCurrentUserInfo(): Observable<EcmUserModel> {
    return this.ecmUserService.getCurrentUserInfo();
  }

  getUserProfileImage(avatarId: string): string {
    return this.ecmUserService.getUserProfileImage(avatarId);
  }
}
